<template>
  <div
    class="Authoritative-certification-content-main"
    :class="{ 'Authoritative-certification-content-main-mobile': isMobile }"
  >
    <div class="headers">令权威信服 令消费者放心</div>
    <div class="main">
      <div class="main-title">贝壳获得的权威认证</div>
      <div class="main-content">
        <!-- <div class="main-content-top">
          <AuthoritativeCertificationContentItem
            v-for="item in dataList"
            :key="item.id"
            :data="item"
          ></AuthoritativeCertificationContentItem>
        </div> -->
        <div class="main-content-bottom">
          <AuthoritativeCertificationContentItem
            v-for="item in list"
            :key="item.id"
            :data="item"
          ></AuthoritativeCertificationContentItem>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AuthoritativeCertificationContent",
  data() {
    return {
      dataList: [
        {
          title: "国家信息系统安全等级保护三级认证",
          content: "贝壳数据存储系统已通过公安部信息安全等级保护三级测评",
          imgUrl: require("@/assets/images/privacyProtect/certification1.png"),
          id: 1,
        },
        {
          title: "可信云服务三级认证",
          content: "贝壳底层云技术已取得 “可信云”三级认证。",
          imgUrl: require("@/assets/images/privacyProtect/certification2.png"),
          id: 2,
        },
      ],
      list: [
        {
          title: "ISO/IEC 27001信息安全管理体系及ISO/IEC27701隐私信息管理体系认证",
          content:
            "BSI是全球权威的标准研发和国际认证评审服务提供商，致力于信息安全领域标准的研发和制定。ISO/IEC 27001信息安全管理体系及ISO/IEC27701隐私信息管理体系认证是国际上针对信息安全和隐私保护领域最权威、最被广泛接受和应用的主流体系认证。贝壳找房是国内首家获得ISO/IEC 27001信息安全管理体系及ISO/IEC27702隐私信息管理体系双重认证的居住服务平台。",
          imgUrl: require("@/assets/images/privacyProtect/certification3.png"),
          id: 3,
        },
        {
          title: "移动互联网应用程序（App）安全认证",
          content: "贝壳找房积极主动拥抱行业监管，配合检测单位完成了针对贝壳找房App开展的技术验证、现场审核、自评监督等系列“X光式”透彻检测。贝壳找房App成功通过国家安全认证，成为行业应用的安全标杆。",
          imgUrl: require("@/assets/images/privacyProtect/certification1.png"),
          id: 4,
        },
        {
          title: "CCIA数据安全和个人信息保护社会责任评价示范单位",
          content: "贝壳找房在2023年3月份依据T/CCIA 002-2022开展的社会责任试点评价工作中作为首批试点单位获得评价。2024年4月，CCIA数安委进一步完善国标《社会责任指南》文本，贝壳找房继2023年的一星级指标要求的基础上，进一步建立了良好的社会责任管理体系，作为责任试点取得更高的社会责任绩效——“二星（计划级）”，再次获得了在数据安全及个人信息保护领域能力建设上的高度认可。",
          imgUrl: require("@/assets/images/privacyProtect/certification2.png"),
          id: 5,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.Authoritative-certification-content-main {
  /* margin-top: 0.36rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc($multiple * 1040px);
  .headers {
    width: 100%;
    height: calc($multiple * 36px);
    text-align: center;
    font-size: calc($multiple * 18px);
    margin-bottom: calc($multiple * 68px);
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #333333;
    line-height: calc($multiple * 36px);
    letter-spacing: 2px;
    margin-top: calc($multiple * 14px);
  }
  .main {
    width: calc($multiple * 1040px);
    // height: calc($multiple * 457px);
    background: #ffffff;
    box-shadow: 0px 2px 12px 2px rgba(226, 226, 226, 0.59);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
  }
  .main-title {
    font-size: calc($multiple * 18px);
    text-align: center;
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #333333;
    line-height: calc($multiple * 36px);
    letter-spacing: 1px;
    margin-top: calc($multiple * 30px);
    margin-bottom: calc($multiple * 39px);
  }
  .main-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 calc($multiple * 56px);
  }
  .main-content-top {
    display: flex;
  }
  .main-content-bottom {
    display: flex;
    flex-direction: column;
  }
}
.Authoritative-certification-content-main-mobile {
  margin-top: 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  .headers {
    margin-top: 1rem;
    margin-bottom: 0;
    font-size: 0.7rem;
    color: #8b8b8b;
  }
  .main {
    width: auto;
    height: auto;
    /* background: #f6faff; */
    box-shadow: 0px 0px 0px 0px;
    .main-title {
      display: none;
    }
    .main-content-top {
      display: flex;
      flex-direction: column;
    }
    .main-content {
      padding: 0 0.86rem;
    }
  }
}

/* .Manage-process-content-main-mobile {
    margin-top: 1.84rem;
    .headers {
      width: 17.15rem;
      height: 3.93rem;
      font-size: 0.61rem;
      line-height: 0.98rem;
      letter-spacing: 0.05rem;
    }
    .main {
      margin-top: 3rem;
      flex-direction: column;
    }
  } */
</style>
